import Icon from '@/components/atoms/icon/icon';
import Image from '@/components/atoms/image/image';
import Typography from '@/components/atoms/typography/typography';
import Link from '@/components/utilities/link/link';
import styles from './media-grid-item.module.scss';

export type MediaGridItemProps = Content.Properties.ImageAndVideoGridItem & {
  /** The text to display on a backdrop */
  backdropText?: string;
  /** The callback to handle the click event */
  onClick?: (id: string) => void;
  /** Indicates whether the image should be loaded immediately */
  priority?: boolean;
};

const MediaGridItem = ({
  backdropText,
  id,
  onClick,
  priority = false,
  ...rest
}: MediaGridItemProps) => {
  const isVideo = 'video' in rest;

  const renderImage = () => {
    const image = isVideo ? rest.video.thumbnailImage : rest.image;

    return (
      <Image
        alt={image.altText}
        className={styles.image}
        focalPoint={image.focalPoint}
        priority={priority}
        src={image.url}
        srcSet={{
          desktop: {
            width: 936,
          },
          laptop: {
            width: 667,
          },
          tablet: {
            width: 405,
          },
        }}
        unoptimized
        width={328}
      />
    );
  };

  const renderOverflow = () => {
    if (!backdropText) return;

    return (
      <div className={styles.overflow}>
        <Icon className={styles.icon} name="Image" size={16} />

        {backdropText}

        <Typography tagStyle="bodyMedium"></Typography>
      </div>
    );
  };

  return (
    <Link className={styles.component} onClick={() => onClick && onClick(id)}>
      {renderImage()}

      {isVideo && !backdropText && (
        <div className={styles.videoIcon}>
          <Icon name="Play" size={16} />
        </div>
      )}

      {renderOverflow()}
    </Link>
  );
};

MediaGridItem.displayName = 'MediaGridItem';

export default MediaGridItem;
